<template>
  <div class="bor">
    <div>
      <div class="font-weight-medium">SPT Registered Date:</div>
      {{ spt.SptDate | formatDate }}
    </div>
    <hr />
    <div>
      <div class="font-weight-medium">Diagnosis:</div>
      {{ spt.Diagnosis }}
    </div>
    <br />
    <table>
      <tr>
        <th class="theader">Allergens</th>
        <th class="theader">SPT results in mm</th>
        <th class="theader">Percentage</th>
      </tr>
      <tr v-for="(item, i) in allergens" :key="i">
        <td>{{ item.Name }}</td>
        <td>{{ item.MmSpt }}</td>
        <td>{{ item.Percentage }}</td>
      </tr>
    </table>

    <br />
  </div>
</template>

<script>
export default {
  props: ["spt"],
  // created() {
  //   if (this.spt.Allergens) this.allergens = JSON.parse(this.spt.Allergens);
  // },
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "Name",
          sortable: true,
          width: "10%"
        },
        {
          text: "SPT results in mm",
          value: "MmSpt",
          sortable: true,
          width: "10%"
        },
        {
          text: "Percentage",
          value: "Percentage",
          sortable: true,
          width: "10%"
        }
      ]
      // allergens: []
    };
  },
  computed: {
    allergens() {
      if (this.spt.Allergens) return JSON.parse(this.spt.Allergens);
      return [];
    }
  }
};
</script>

<style scoped>
.bor {
  border: solid grey 1px;
  padding: 1%;
}
hr {
  color: #ffffff;
  margin-top: 5px;
  margin-bottom: 5px;
}
table {
  border-collapse: collapse;
}
table,
th,
td {
  border: 1px solid grey;
}
.theader {
  width: 1%;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}
td {
  font-size: 14px;
  text-align: center;
}
</style>
